export const IconName = {
  ADD_CIRCLE: 'add-circle',
  CLOSE: 'close',
  DELETE: 'delete',
  DOTS_VERTICAL: 'dots-vertical',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  PLUS: 'plus',
  MINUS: 'minus',
  EYE: 'eye',
  DOCUMENT_DOWNLOAD: 'document-download',
  FILE_PDF: 'file-pdf',
  FILE_IMAGE: 'file-image',
  FILE_VIDEO: 'file-video',
  FILE_AUDIO: 'file-audio',
  FILE_PRESENTATION: 'file-presentation',
  FILE_DOCUMENT: 'file-document',
} as const;
export type IconName = (typeof IconName)[keyof typeof IconName];

// Sizes replicating the Icon component's Size variant in Figma. The px value
// for each is mapped in icon.vue.
export const IconSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];
